import { render, staticRenderFns } from "./EraDetail.vue?vue&type=template&id=2c01b0c4&"
import script from "./EraDetail.vue?vue&type=script&lang=js&"
export * from "./EraDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports